import { ReactNode } from 'react'
import { usePullToRefresh } from '@/hooks/usePullToRefresh'
import { RefreshCw } from 'lucide-react'
import { cn } from '@/lib/utils'

interface PullToRefreshContainerProps {
  children: ReactNode
  onRefresh: () => Promise<void>
}

export const PullToRefreshContainer = ({
  children,
  onRefresh,
}: PullToRefreshContainerProps) => {
  const { isRefreshing, pullDistance, progress, ...touchHandlers } =
    usePullToRefresh({
      onRefresh,
    })

  return (
    <div className="relative overflow-hidden">
      <div
        className="absolute top-0 left-0 right-0 flex items-center justify-center transition-all duration-200"
        style={{
          height: `${pullDistance}px`,
          opacity: pullDistance > 0 ? 1 : 0,
        }}
        aria-live="polite"
        aria-label={isRefreshing ? 'Refreshing content' : 'Pull to refresh'}
      >
        <RefreshCw
          className={cn('w-6 h-6 text-primary', isRefreshing && 'animate-spin')}
          style={{
            transform: `rotate(${progress * 3.6}deg)`,
          }}
          aria-hidden="true"
        />
      </div>

      <div
        {...touchHandlers}
        style={{
          transform: `translateY(${pullDistance}px)`,
          transition: isRefreshing ? 'transform 0.2s ease-out' : 'none',
        }}
      >
        {children}
      </div>
    </div>
  )
}
